import { daySegments } from 'config/common.config';

export const getSurfAlertDayGroups = (marineEntries = []) => {
  const dayGroups = new Map();

  marineEntries.filter(Boolean).forEach((entry) => {
    if (!daySegments.includes(entry?.day_segment)) return; // Skip entries with invalid day segments

    const entryDate = new Date(entry?.iso8601);
    if (isNaN(entryDate.getTime())) return; // Skip entries with invalid dates

    // Gets midnight timestamp for the entry's date by omitting the time portion forcing it to default to 00:00:00
    const dayTimestamp = new Date(
      entryDate.getFullYear(),
      entryDate.getMonth(),
      entryDate.getDate(),
    ).getTime();

    // Each day group contains a map of Morning, Afternoon, Evening, and Night segments
    const dayGroup = dayGroups.get(dayTimestamp) ?? {
      dayTimestamp,
      date: entryDate,
      segmentEntries: new Map(),
    };

    dayGroup.segmentEntries.set(entry.day_segment, entry);
    dayGroups.set(dayTimestamp, dayGroup);
  });

  return Array.from(dayGroups.values())
    .sort(
      (firstGroup, secondGroup) => firstGroup.dayTimestamp - secondGroup.dayTimestamp, // Sort in ascending order by day timestamp (earliest to latest)
    )
    .map(({ dayTimestamp, date, segmentEntries }) => {
      const marineData = daySegments.map((segment) => segmentEntries.get(segment)).filter(Boolean); // Removes any falsy values
      return {
        dayTimestamp,
        marineData, // Morning, Afternoon, Evening, Night segments for the day
        // The label for the day of the week, e.g., "Monday"
        weekdayLabel:
          marineData[0]?.weekday ?? date.toLocaleDateString('en-US', { weekday: 'long' }),
        dateLabel: date.toLocaleDateString('en-US'), // The formatted date string for the day, e.g., "6/15/2024"
      };
    });
};
